<template>
  <div>
     <el-row :gutter="10">
       <el-col :span="5">
         <el-card class="box-card">

         <el-input type="textarea" v-model="goodsIdText"
                   :rows="30"
                   placeholder="请输入商品id,多个商品请换行"
         ></el-input>
         </el-card>
       </el-col>
       <el-col :span="19">
         <el-button icon="el-icon-search" @click="generateLinks" >生成短链接</el-button>
         <el-divider></el-divider>
         <el-table  :data="generatedLinksInfo" stripe>
           <el-table-column prop="goodsId" label="商品ID"></el-table-column>
           <el-table-column prop="shortUrl" label="抖音短链接"></el-table-column>
           <el-table-column prop="originUrl" label="商品链接"></el-table-column>
         </el-table>
       </el-col>
     </el-row>
  </div>
</template>
<style>
.text {
  font-size: 14px;
}

.item {
  padding: 18px 0;
}
</style>
<script>
import axios from 'axios'

export default {
  name: "watermarkTools",
  data() {
    return {
      goodsId: '',
      goodsIds: [],
      goodsIdText:'',
      generatedLinksInfo: [],
      douyinCode:'',
      originUrl:''
    };
  },
  methods: {
    copyUrl() {
      this.$clipboard(this.uploadedLink)
    },
    generateLinks(){
      const _self = this;
      if(this.goodsIdText === '') {
        alert('请输入商品ID.')
        return;
      }

      this.goodsIds = this.goodsIdText.split('\n')
      if(this.goodsIdText.length === 0) {
        alert('请输入商品ID.')
        return;
      } else {
        _self.processLink();
      }

    },
    processLink() {
      const _self = this;
      if(this.goodsIds.length > 0) {
        const processGoodsId = this.goodsIds.shift();
        axios.get("/api/douyin/generateDouCode?goodsId=" + processGoodsId)
            .then((content) => {
              if(content.data.status.code === '0') {
                const goodsInfo = content.data.data;
                goodsInfo.goodsId = processGoodsId;
                _self.generatedLinksInfo.push(content.data.data)
                setTimeout(_self.processLink,200)
              }
        });
      } else {
        alert('无待处理的商品ID');
      }
    },
    generate() {
      const _self = this;
      if(this.goodsId === '') {
        alert('请输入商品ID.')
        return;
      }
      axios
          .get("/api/douyin/generateDouCode?goodsId="+this.goodsId)
          .then((content) => {
            console.log(content)
            if(content.data.status.code === '0') {
              _self.douyinCode = content.data.data.shortUrl
              _self.originUrl = content.data.data.originUrl
            }
          });
    },
  },
  mounted() {
  },
};
</script>
